import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';
import { UpOutlined, DownOutlined, SearchOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  Col,
  Form,
  Input,
  Row,
  Modal,
  Button,
  Space,
  Typography,
  Image,
  Divider,
} from 'antd';
import { returnRedeemCode } from '../../../services/api';

export type Props = {
  orders: any;
  type: string;
  onTabChangeState: (tabKey?: string) => any;
};

const MyOrders: React.FC<Props> = (props) => {
  const { orders = [], type } = props;
  let [formSearch] = Form.useForm();
  const [modalCanClePay, setModalCanClePay] = useState<any>(false);
  const [modalCancleCheckPay, setModalCancleCheckPay] =
    useState<boolean>(false);
  const [modalCancleShip, setModalCancleShip] = useState<boolean>(false);
  const [modalCheckCancel, setModalCheckCancel] = useState<boolean>(false);
  const [modalConfirmShip, setModalConfirmShip] = useState<boolean>(false);
  const navigate = useNavigate();
  const { Text } = Typography;
  const [myOrders, setMyOrders] = useState<any>([]);
  const [statusOnCancel, setStatusOnCancel] = useState<string>('');
  const [cancelPay, setCancelPay] = useState('');
  const [checkCancelPay, setCheckCancelpay] = useState('');
  const [cancelShip, setCancelShip] = useState('');
  const [deliveredUpdateId, setDeliveredUpdateId] = useState('');
  const [orderId, setOrderId] = useState<string>('');
  const [selectedOrder, setSelectedOrder] = useState();
  const [userProductsIds, setUserProductsIds] = useState<any>();
  const [allProducSeach, setAllProducSeach] = useState<any>();

  useEffect(() => {}, [selectedOrder]);

  const [resonObject, setResonObject] = useState({
    reason: '',
    shopId: '',
  });

  const settothai = (status: string) => {
    let thaistatus = '';

    if (status === 'waiting_payment') {
      thaistatus = 'รอชำระเงิน';
    } else if (status === 'waiting_new_payment') {
      thaistatus = 'แจ้งชำระเงินใหม่';
    } else if (status === 'check_payment') {
      thaistatus = 'ตรวจสอบการชำระเงิน';
    } else if (status === 'on_delivery') {
      thaistatus = 'ผู้ขายกำลังเตรียมการจัดส่ง';
    } else if (status === 'shipping') {
      thaistatus = 'กำลังจัดส่ง';
    } else if (status === 'delivery') {
      thaistatus = 'จัดส่งสำเร็จ';
    } else if (status === 'success') {
      thaistatus = 'เสร็จสิ้น';
    } else if (status === 'cancelled') {
      thaistatus = 'ยกเลิก';
    } else if (status === 'checkCancel') {
      thaistatus = 'ตรวจสอบคำร้องขอยกเลิก';
    }
    return thaistatus;
  };

  const changeStatusToCancel = async () => {
    const status =
      statusOnCancel === 'check_payment'
        ? `${statusOnCancel}_cancel`
        : 'cancelled';

    const data = {
      type: 'update_status',
      reason: resonObject.reason,
      cancelOrder: true,
      status,
      orderId,
    };

    await axios.patch(`/orders/${resonObject.shopId}`, data);

    if (statusOnCancel !== 'check_payment') {
      axios.post(`/line/send-messages`, {
        type: 'order_cancelled',
        orderId,
      });
    }

    if (selectedOrder) {
      await returnRedeemCode(selectedOrder['_id']);
    }

    if (userProductsIds?.length) {
      for (let i = 0; i < userProductsIds?.length; i++) {
        const dataOrderShop = {
          stock: userProductsIds[i]?.newStock,
        };
        await axios.patch(
          `/user-product/${userProductsIds[i]?.userProductId}`,
          dataOrderShop
        );
      }
    }

    window.location.reload();
  };

  const changeStatusToDelivered = async () => {
    const data = {
      status: 'success',
    };
    if (deliveredUpdateId) {
      await axios.patch(`/orders/${deliveredUpdateId}`, data);
    }

    window.location.reload();
  };

  const sentState = (value?: string) => {
    props.onTabChangeState(value);
  };
  const onClickModalConfirmDelivered = (order: any, index: number) => {
    setDeliveredUpdateId(order._id);
  };

  const onClickModalCancel = (order: any, index: number) => {
    const userProductsIdArray: any[] = [];
    if (order.status === 'waiting_payment') {
      order.shops.map((x: any) => {
        x.orderShop.products.map((y: any) => {
          const obj = {
            userProductId: y.product._id._id,
            newStock: y.amount + y.product._id.stock,
          };
          userProductsIdArray.push(obj);
        });
      });
      if (userProductsIdArray.length) {
        setUserProductsIds(userProductsIdArray);
      }
    }
    setSelectedOrder(order);
    setOrderId(order._id);
    if (order.status === 'waiting_payment') {
      setModalCanClePay(true);
    } else if (order.status === 'check_payment') {
      setModalCancleCheckPay(true);
      setStatusOnCancel(order.status);
    } else if (order.status === 'on_delivery') {
      setModalCancleShip(true);
    }

    setResonObject({
      ...resonObject,
      shopId: order._id,
    });
  };

  const onReasonChange = (e: any) => {
    const value = e.target.value;
    setResonObject({
      ...resonObject,
      reason: `จากผู้ซื้อ, ${value}`,
    });
  };

  const onCollapedClick = async (order: any, shop: any, index: number) => {
    const getGift = async (productCode: string) => {
      if (productCode) {
        const { data } = await axios.get(`/products/scg/detail/${productCode}`);
        return data;
      } else {
        return false;
      }
    };

    const odrs: any = await Promise.all(
      myOrders.map(async (x: any) => {
        return {
          ...x,
          shops: await Promise.all(
            x.shops.map(async (y: any) => {
              return {
                ...y,
                isCollaped:
                  x._id === order._id && y._id === shop._id
                    ? !shop.isCollaped
                    : y.isCollaped,
                gift: await getGift(
                  y?.orderShop?.promotion_type === 'freegift'
                    ? y.orderShop.promotion?.promotionFreegiftRule
                        ?.freegiftProductId
                    : ''
                ),
              };
            })
          ),
        };
      })
    );
    setMyOrders(odrs);
  };

  const searchOrder = (values: any) => {
    const value = values.toLowerCase();
    setAllProducSeach(value);
  };
  const searchButton = async (e: any) => {
    let check = e.key ? e.key : e;
    if (check === 'Enter') {
      const odrs = orders.map((x: any) => ({
        ...x,
        orderShopId: x.shops.map((y: any) => y?.orderShop?._id),
        orderNo: x.shops.map((y: any) => y?.orderShop?.orderNo),
        shopName: x.shops.map((y: any) => y?.shop?.name),
      }));
      let value = allProducSeach;

      let newOrder = [];
      for (let i = 0; i < odrs.length; i++) {
        const matchText = odrs[i].orderShopId
          .toString()
          .toLowerCase()
          .match(value);
        const matchText4 = odrs[i].orderNo
          .toString()
          .toLowerCase()
          .match(value);
        const matchText2 = odrs[i].shopName
          .toString()
          .toLowerCase()
          .match(value);

        const matchText3 = odrs[i]?.shops.some((shopArray: any) =>
          shopArray?.orderShop?.products.some((productArray: any) =>
            Object.values(productArray).some((obj: any) => {
              let hasProductName = false;
              if (obj._id) {
                hasProductName = obj._id.product.productName
                  .toLowerCase()
                  .includes(value);
              }
              return hasProductName;
            })
          )
        );

        if (matchText) {
          newOrder.push(odrs[i]);
        } else if (matchText4) {
          newOrder.push(odrs[i]);
        } else if (matchText2) {
          newOrder.push(odrs[i]);
        } else if (matchText3) {
          newOrder.push(odrs[i]);
        }
      }
      if (newOrder) {
        setMyOrders(newOrder);
      }
    }
  };

  useEffect(() => {
    const odrs = orders.map((x: any) => ({
      ...x,
      shops: x.shops.map((y: any) => ({ ...y, isCollaped: true })),
    }));

    setMyOrders(odrs);
    formSearch.setFieldsValue({ search: null });
  }, [orders]);

  const plustime = (time: string) => {
    if (time === null) return;
    let xtime = time?.substring(0, 2);
    let date = time?.substring(2, 6);
    let conint = parseInt(xtime) + 1;
    let datetime = conint.toString() + date;

    return datetime;
  };

  return (
    <>
      <Row justify='space-around'>
        <Col span={22}>
          <Form form={formSearch}>
            <Form.Item name='search' noStyle>
              <Input
                name='search'
                onChange={(e) => {
                  searchOrder(e.target.value);
                }}
                placeholder='ค้นหาสินค้า'
                onKeyDown={(e) => {
                  searchButton(e);
                }}
              />
            </Form.Item>
          </Form>
        </Col>
        <Col span={2}>
          <Button
            type='primary'
            onClick={() => {
              searchButton('Enter');
            }}
            className={styles.inputSearch}
            style={{ marginLeft: 5 }}
          >
            <SearchOutlined />
          </Button>
        </Col>
      </Row>

      {myOrders.map((order: any, indexOrder: number) => (
        <div className={styles.detailproduct}>
          <div key={indexOrder} className={styles.containerbox}>
            {order.shops.map((shop: any, indexShop: number) => (
              <div key={indexShop}>
                {' '}
                {indexShop > 0 ? (
                  <div className={styles.boxborderbutton}></div>
                ) : (
                  ''
                )}
                <Row
                  className={styles.headorder}
                  justify='space-between'
                  style={{ paddingTop: '10px' }}
                >
                  <Col xs={24} sm={24} md={24} lg={15} xl={15}>
                    <Row>
                      <Col xs={24} sm={24} md={4} lg={6} xl={6}>
                        <img
                          src={
                            order?.shops[indexShop]?.shop?.document
                              ?.shopImageUrl === undefined
                              ? '/images/account_box_24px.svg'
                              : order?.shops[indexShop]?.shop?.document
                                  ?.shopImageUrl
                          }
                          height={35}
                          alt=''
                        />
                        &nbsp;
                        {order?.shops[indexShop]?.shop?.name}
                      </Col>

                      <Col
                        xs={24}
                        sm={24}
                        md={6}
                        lg={8}
                        xl={8}
                        style={{ marginTop: '5px' }}
                      >
                        {shop?.orderShop?.deliveryType !== undefined
                          ? 'ตัวเลือกจัดส่ง: ' + shop?.orderShop?.deliveryType
                          : ''}
                      </Col>

                      <Col
                        xs={24}
                        sm={24}
                        md={10}
                        lg={10}
                        xl={9}
                        style={{ marginTop: '5px' }}
                      >
                        <Text style={{ color: '#2D6FA5', fontSize: 12 }}>
                          {order.orderType !== 'order_offline' &&
                          order.shops[indexOrder]?.orderShop?.shipmentDate !==
                            undefined
                            ? '(' +
                              order.shops[indexOrder]?.orderShop?.shipmentDate +
                              ' เวลา ' +
                              order.shops[indexOrder]?.orderShop?.shipmentTime +
                              '-' +
                              plustime(
                                order.shops[indexOrder]?.orderShop?.shipmentTime
                              ) +
                              'น.)'
                            : order.orderType === 'order_offline' &&
                              order.shops[indexOrder]?.orderShop
                                ?.deliveryType === 'จัดส่งปกติ'
                            ? `(เวลา ${order.shops[indexOrder]?.orderShop?.shipmentPeriod} น.)`
                            : ''}
                        </Text>
                      </Col>
                    </Row>
                  </Col>
                  <Col style={{ marginTop: '5px' }}>
                    <Space align='end'>
                      <Row>
                        <Col style={{ fontSize: 12 }}>
                          {shop?.orderShop?.orderNo
                            ? shop?.orderShop?.orderNo
                            : shop?.orderShop?._id}{' '}
                          | {/* {shop?.orderShop?._id} |{' '} */}
                        </Col>
                        <Col style={{ fontSize: 12, color: '#2D6FA5' }}>
                          &nbsp; {settothai(shop?.orderShop?.status)}
                        </Col>
                      </Row>
                    </Space>
                  </Col>
                </Row>
                <div className={styles.productWrapper}>
                  {shop.isCollaped ? (
                    <>
                      <div>
                        <Row
                          className={styles.detailproduct}
                          justify='space-between'
                          style={{ paddingTop: '10px' }}
                        >
                          <Col>
                            <Image
                              width={100}
                              src={
                                shop?.orderShop?.products[0]?.product?._id
                                  ?.product?.files[0]
                              }
                            />
                          </Col>
                          <Col xs={8} sm={18} md={18} lg={18} xl={19}>
                            <Col>
                              <Text>
                                {
                                  shop?.orderShop?.products[0]?.product?._id
                                    ?.product?.productName
                                }
                              </Text>
                            </Col>
                            <Col style={{ marginTop: '15px' }}>
                              <Text style={{ color: '#828282' }}>
                                {shop?.orderShop?.products[0]?.amount} ชิ้น
                              </Text>
                            </Col>
                          </Col>
                          <Col xs={4} sm={2} md={2} lg={2} xl={2}>
                            <Space align='end'>
                              <Text style={{ color: '#2D6FA5' }}>
                                ฿{shop?.orderShop?.products[0]?.wholesalePrice}
                              </Text>
                            </Space>
                          </Col>
                        </Row>
                      </div>
                      <div className={styles.boxborderbutton}></div>
                    </>
                  ) : (
                    <>
                      {shop?.orderShop?.products.map(
                        (item: any, index: number) => (
                          <div key={index}>
                            <Row
                              className={styles.detailproduct}
                              justify='space-between'
                              style={{ paddingTop: '10px' }}
                            >
                              <Col>
                                <Image
                                  width={100}
                                  src={item?.product?._id?.product?.files[0]}
                                />
                              </Col>
                              <Col xs={8} sm={18} md={18} lg={18} xl={19}>
                                <Col>
                                  <Text>
                                    {item.product._id.product.productName}
                                  </Text>
                                </Col>
                                <Col style={{ marginTop: '15px' }}>
                                  <Text style={{ color: '#828282' }}>
                                    {' '}
                                    {item.amount} ชิ้น
                                  </Text>
                                </Col>
                              </Col>
                              <Col xs={4} sm={2} md={2} lg={2} xl={2}>
                                <Space align='end'>
                                  <Text style={{ color: '#2D6FA5' }}>
                                    ฿
                                    {
                                      shop?.orderShop?.products[0]
                                        ?.wholesalePrice
                                    }
                                  </Text>
                                </Space>
                              </Col>
                            </Row>
                          </div>
                        )
                      )}
                      {shop?.gift ? (
                        <>
                          <Row
                            className={styles.detailproduct}
                            justify='space-between'
                            style={{ paddingTop: '10px' }}
                          >
                            <Col>
                              <Image width={100} src={shop?.gift?.files[0]} />
                            </Col>
                            <Col xs={8} sm={18} md={18} lg={18} xl={19}>
                              <Col>
                                <Text>
                                  {`(ของแถม) ${shop?.gift?.productName}`}
                                </Text>
                              </Col>
                              <Col style={{ marginTop: '15px' }}>
                                <Text style={{ color: '#828282' }}>
                                  {
                                    shop?.orderShop?.promotion
                                      ?.promotionFreegiftRule?.freegiftLimitQty
                                  }{' '}
                                  ชิ้น
                                </Text>
                              </Col>
                            </Col>
                            <Col xs={4} sm={2} md={2} lg={2} xl={2}>
                              <Space align='end'>
                                <Text style={{ color: '#2D6FA5' }}>฿{0.0}</Text>
                              </Space>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <></>
                      )}
                      <div className={styles.boxborderbutton}></div>
                      <div>
                        <Row
                          justify='space-between'
                          style={{ margin: '10px 0px' }}
                        >
                          <Space align='start'>
                            <Text>วันที่สั่งซื้อ: {order.formatCreatedAt}</Text>
                          </Space>

                          <Space align='end'>
                            <Text>ราคา </Text>
                            <Text style={{ color: '#2D6FA5' }}>
                              ฿{' '}
                              {shop?.orderShop?.totalPrice +
                                (shop.orderShop?.discount || 0)}
                            </Text>
                          </Space>
                        </Row>

                        <Row
                          justify='space-between'
                          style={{ margin: '10px 0px' }}
                        >
                          <Space align='start'>
                            <Text>
                              สถานที่จัดส่ง:
                              {order?.address?.address}&nbsp; อ.
                              {order?.address?.city?.name}&nbsp; ต.
                              {order?.address?.subCity?.name}&nbsp; จ.
                              {order?.address?.state?.name}&nbsp;
                              {order?.address?.postalCode}
                            </Text>
                          </Space>

                          <Space align='end'>
                            <Text>ส่วนลด </Text>
                            <Text style={{ color: '#2D6FA5' }}>
                              ฿{shop.orderShop?.discount || '0.00'}
                            </Text>
                          </Space>
                        </Row>

                        <Row
                          justify='space-between'
                          style={{ margin: '10px 0px' }}
                        >
                          <Space align='start'>
                            <Text>
                              โน้ตที่ส่งถึงร้านค้า: {shop?.orderShop?.remark}
                            </Text>
                          </Space>

                          <Space align='end'>
                            <Text>ค่าขนส่ง </Text>
                            <Text style={{ color: '#2D6FA5' }}>
                              ฿ {shop?.orderShop?.shipment}
                            </Text>
                          </Space>
                        </Row>
                      </div>
                    </>
                  )}
                </div>
                <div
                  className={styles.hiddingtabs}
                  onClick={() => {
                    onCollapedClick(order, shop, indexOrder);
                  }}
                >
                  {shop.isCollaped ? (
                    <div>
                      ดูรายละเอียดเพิ่มเติม &nbsp;
                      <DownOutlined />
                    </div>
                  ) : (
                    <div>
                      ซ่อนรายละเอียด &nbsp;
                      <UpOutlined />
                    </div>
                  )}
                </div>
              </div>
            ))}
            <Row justify='space-between' style={{ margin: '10px 0px' }}>
              <Space align='start'>
                <Text> รวมสินค้า {order?.allAmount} ชิ้น</Text>
              </Space>
              <div className={styles.boxborderbutton}></div>
              <Space align='end'>
                <Text>ราคาสุทธิ ฿{order.totalPrice}</Text>
              </Space>
            </Row>

            <div className={styles.boxborderbutton}></div>
            <Row justify='space-between' style={{ margin: '10px 0px' }}>
              <Space align='start'>
                {type === 'waiting_payment' && (
                  <Text style={{ color: '#2D6FA5' }}>
                    คำสั่งซื้อจะถูกยกเลิกหากท่านไม่ชำระเงินภายใน 48ชั่วโมง
                  </Text>
                )}
                {type === 'check_payment' && (
                  <Text style={{ color: '#2D6FA5' }}>
                    แอดมินกำลังตรวจสอบคำสั่งซื้อ
                  </Text>
                )}

                {type === 'on_delivery' && (
                  <Text style={{ color: '#2D6FA5' }}>
                    คำสั่งซื้อของท่านอยู่ระหว่างเตรียมการจัดส่ง
                  </Text>
                )}
                {type === 'shipping' && (
                  <Text style={{ color: '#2D6FA5' }}>
                    คำสั่งซื้อของท่านอยู่ระหว่างจัดส่งท่านจะได้รับสินค้าภายใน 7
                    วันหลังการชำระเงิน
                  </Text>
                )}

                {type === 'delivery' && (
                  <Text style={{ color: '#2D6FA5' }}>
                    คำสั่งซื้อของท่านจัดส่งสำเร็จแล้วกรุณาตรวจสอบสินค้าและยืนยันรับสินค้า
                  </Text>
                )}

                {type === 'success' && (
                  <Text style={{ color: '#2D6FA5' }}>
                    คำสั่งซื้อของท่านจัดส่งสำเร็จแล้ว
                  </Text>
                )}

                {type === 'cancelled' && (
                  <Text style={{ color: '#2D6FA5' }}>
                    คำสั่งซื้อถูกยกเลิกเนื่องจาก :{' '}
                    {order.reason !== undefined && order.reason}
                  </Text>
                )}
                {type === 'shop_prepare_delivery_cancel' && (
                  <Text style={{ color: '#2D6FA5' }}>
                    คำสั่งซื้อของท่านอยู่ระหว่างตรวจสอบคำร้องขอยกเลิก
                  </Text>
                )}
                {type === 'check_payment_cancel' && (
                  <Text style={{ color: '#2D6FA5' }}>
                    คำสั่งซื้อของท่านอยู่ระหว่างตรวจสอบคำร้องขอยกเลิก
                  </Text>
                )}
              </Space>

              <Space align='end'>
                {type === 'waiting_payment' && (
                  <>
                    <Button
                      type='primary'
                      ghost
                      onClick={() => {
                        setCancelPay('');
                        onClickModalCancel(order, indexOrder);
                      }}
                    >
                      ยกเลิกคำสั่งซื้อ
                    </Button>
                    <Button
                      type='primary'
                      onClick={() => {
                        order.totalPrice || order.address
                          ? navigate(`/cart/confirm-payment?id=${order._id}`)
                          : navigate(
                              `/cart/confirm-order-summary?id=${order._id}`
                            );
                      }}
                    >
                      ชำระเงิน
                    </Button>
                  </>
                )}

                {type === 'check_payment' && (
                  <Button
                    type='primary'
                    ghost
                    onClick={() => {
                      setCheckCancelpay('');
                      onClickModalCancel(order, indexOrder);
                    }}
                  >
                    ยกเลิกคำสั่งซื้อ
                  </Button>
                )}
                {type === 'on_delivery' && (
                  <Button
                    type='primary'
                    ghost
                    onClick={() => {
                      setCancelShip('');
                      onClickModalCancel(order, indexOrder);
                    }}
                  >
                    ยกเลิกคำสั่งซื้อ
                  </Button>
                )}
                {type === 'delivery' && (
                  <Button
                    type='primary'
                    onClick={() => {
                      onClickModalConfirmDelivered(order, indexOrder);
                      setModalConfirmShip(true);
                    }}
                  >
                    ยืนยันรับสินค้า
                  </Button>
                )}

                {type === 'checkCancel' && (
                  <Button
                    type='primary'
                    ghost
                    onClick={() => {
                      onClickModalCancel(order, indexOrder);
                    }}
                  >
                    ยกเลิกคำร้องขอยกเลิก
                  </Button>
                )}
              </Space>
            </Row>
          </div>

          <Divider style={{ backgroundColor: '#d9d9d9' }}></Divider>
        </div>
      ))}

      <Modal
        title=''
        centered
        visible={modalCanClePay}
        onOk={() => ''}
        onCancel={() => setModalCanClePay(false)}
        footer={null}
        width={336}
      >
        <Row justify='center'>
          <Text>กรุณากรอกสาเหตุที่ยกเลิก</Text>
        </Row>
        <Row justify='space-around' style={{ marginTop: '10px' }}>
          <Form.Item rules={[{ required: true, message: 'Input something!' }]}>
            <Input
              className={styles.inputtextcancle}
              type='text'
              placeholder='กรุณากรอกสาเหตุ'
              value={cancelPay}
              name='CancleTextModal'
              onChange={(e: any) => {
                onReasonChange(e);
                setCancelPay(e.target.value);
              }}
            />
            <Button
              type='primary'
              htmlType='submit'
              className={styles.button_submit}
              onClick={(e: any) => {
                if (cancelPay !== '') {
                  setModalCanClePay(false);
                  changeStatusToCancel();
                  sentState('cancelled');
                }
              }}
            >
              ตกลง
            </Button>
          </Form.Item>
        </Row>
      </Modal>
      {/* modalcheckpay */}
      <Modal
        title=''
        centered
        visible={modalCancleCheckPay}
        onOk={() => ''}
        onCancel={() => setModalCancleCheckPay(false)}
        footer={null}
        width={336}
      >
        <Row justify='center'>
          <Text>กรุณากรอกสาเหตุที่ยกเลิก</Text>
        </Row>
        <Row justify='space-around' style={{ marginTop: '10px' }}>
          <Form.Item
            rules={[
              {
                required: false,
                message: 'กรุณากรอกข้อมูล!',
              },
            ]}
          >
            <Input
              className={styles.inputtextcancle}
              value={checkCancelPay}
              placeholder='กรุณากรอกสาเหตุ'
              type='text'
              name='CancleChekPayModal'
              onChange={(e: any) => {
                onReasonChange(e);
                setCheckCancelpay(e.target.value);
              }}
            />
            <Button
              type='primary'
              className={styles.button_submit}
              onClick={() => {
                if (checkCancelPay !== '') {
                  setModalCancleCheckPay(false);
                  changeStatusToCancel();
                  sentState('cancelled');
                }
              }}
            >
              ตกลง
            </Button>
          </Form.Item>
        </Row>
      </Modal>
      {/* {prepareship} */}
      <Modal
        title=''
        centered
        visible={modalCancleShip}
        onOk={() => ''}
        onCancel={() => setModalCancleShip(false)}
        footer={null}
        width={336}
      >
        <Row justify='center'>
          <Text>กรุณากรอกสาเหตุที่ยกเลิก</Text>
        </Row>
        <Row justify='space-around' style={{ marginTop: '10px' }}>
          <Form.Item
            rules={[
              {
                required: true,
                message: 'กรุณากรอกข้อมูล!',
              },
            ]}
          >
            <Input
              className={styles.inputtextcancle}
              type='text'
              value={cancelShip}
              placeholder='กรุณากรอกสาเหตุ'
              name='CancleTextShipModal'
              onChange={(e: any) => {
                onReasonChange(e);
                setCancelShip(e.target.value);
              }}
            />
            <Button
              type='primary'
              className={styles.button_submit}
              onClick={() => {
                if (cancelShip !== '') {
                  setModalCancleShip(false);
                  changeStatusToCancel();
                  sentState('cancelled');
                }
              }}
            >
              ตกลง
            </Button>
          </Form.Item>
        </Row>
      </Modal>
      {/* {ConfirmAcceptCate} */}
      <Modal
        title=''
        centered
        visible={modalConfirmShip}
        onOk={() => ''}
        onCancel={() => setModalConfirmShip(false)}
        footer={null}
        width={336}
      >
        <Row justify='center'>
          <Text>ท่านได้ตรวจสอบสินค้าและยืนยันการรับสินค้า</Text>

          <Button
            type='primary'
            className={styles.button_submit}
            onClick={() => {
              setModalConfirmShip(false);
              changeStatusToDelivered();
              sentState('success');
            }}
          >
            ตกลง
          </Button>
        </Row>
      </Modal>
    </>
  );
};

export default MyOrders;
